export type MimeTypeError = {
  valid: false;
  errorType: 'mimeType';
  mimeType: string;
};

export type SizeError = {
  valid: false;
  errorType: 'size';
  size: number;
};

/**
 * Union type representing all possible file validation errors.
 */
export type FileError = MimeTypeError | SizeError;

export function isMimeTypeError(error: unknown): error is MimeTypeError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'valid' in error &&
    error.valid === false &&
    'errorType' in error &&
    error.errorType === 'mimeType'
  );
}

export function isSizeError(error: unknown): error is SizeError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'valid' in error &&
    error.valid === false &&
    'errorType' in error &&
    error.errorType === 'size'
  );
}

export type FileSuccess = {
  valid: true;
};

export type FileValidationResult = FileSuccess | FileError;

export interface CreateFileValidatorParams {
  /** Set of allowed MIME types that files must match */
  allowedMimeTypes: Set<string>;
  /** Maximum allowed file size in bytes */
  maxFileSize: number;
}
